<div class="scroll-wrapper background-hover"
     [style.z-index]="18"
     [style.max-width]="canvasAreaWidth"
     [style.min-width]="canvasAreaWidth"
     [style.max-height]="canvasAreaHeight"
     [style.min-height]="canvasAreaHeight"
>
  <div class="scroll-content" #scrollContent>
    <ng-content></ng-content>
  </div>
  <div
    #scrollbarThumbVertical
    class="scrollbar-thumb vertical background-shape-border"
    [style.z-index]="16"
    [hidden]="!showVertical"
    (dragstart)="onDragStart($event)"
    (mousedown)="onThumbStart($event, true)"
    (touchstart)="onThumbStart($event, true)"
  ></div>
  <div
    #scrollbarThumbHorizontal
    class="scrollbar-thumb horizontal background-shape-border"
    [style.z-index]="16"
    [hidden]="!showHorizontal"
    (dragstart)="onDragStart($event)"
    (mousedown)="onThumbStart($event, false)"
    (touchstart)="onThumbStart($event, false)"
  ></div>

  <div *ngIf="showVertical && showHorizontal" class="corner background-hover" [style.z-index]="17"></div>
</div>
